(function($){
  $(document).ready(function(){

    $('.title-cta').once('sw-title-cta').each(function(){
      const $tc = $(this);
      const $cta = $tc.find('.as-b');
      const $section = $tc.closest('.section');

      // Adding mobile-only link at the bottom of the section
      const $actions = $('<div class="title-cta-bot-actions actions tac mobile">');
      const $cta2 = $cta.clone();
      $actions.append($cta2);
      $section.append($actions);
    });

  });
})(jQuery);
